module.exports = __webpack_public_path__ + "img/team-towers@2x.daafe753.jpg";